// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\">Federal Loan Deferment & Forbearance Forms</h1> ";
// Exports
export default code;